export enum FinancielMatrixBankSlipOrientation {
  LANDSCAPE = 'LANDSCAPE',
  PORTRAIT = 'PORTRAIT',
}

export const FinancielMatrixBankSlipOrientationLabel = {
  LANDSCAPE: 'Paisagem',
  PORTRAIT: 'Retrato',
};

export interface FinancialMatrixSettings {
  bankSlipPaidBeforeDueDate: boolean;
  autoSettleOnBankSlipPayment: boolean;
  bankSlipOrientation: FinancielMatrixBankSlipOrientation;
  id: number;
}

export interface FinancialMatrixSettingsCreateRequest {
  bankSlipPaidBeforeDueDate: boolean;
  autoSettleOnBankSlipPayment: boolean;
  bankSlipOrientation: FinancielMatrixBankSlipOrientation;
}

export interface FinancialMatrixSettingsUpdateRequest {
  bankSlipPaidBeforeDueDate: boolean;
  autoSettleOnBankSlipPayment: boolean;
  bankSlipOrientation: FinancielMatrixBankSlipOrientation;
  id: number;
}
